import React from "react";

const SectionHeading = ({heading, className}) => {
  const data = heading;
  const addAllClasses = ["max-w-3xl m-auto mb-5 md:mb-10"];
  addAllClasses.push(className)
  if(Object.keys(data.align).length > 0) {
    addAllClasses.push(`text-center md:text-${data.align} `)
  }
  return (
    <div className={addAllClasses.join(" ")}>
      {data?.SectionTitle && <h2 className="my-3  text-2xl md:text-4xl font-bold">{data.SectionTitle}</h2>}
      {data?.SubHeading && <p className="	text-base md:text-lg">{data.SubHeading}</p>}
    </div>
  );
};

export default SectionHeading;
